import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Field, Form, Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import Button from "react-bootstrap/Button";
import { Row, Col } from "react-bootstrap";
import signUpService from "../../../components/Services/signUp.service";
import { useSelector } from "react-redux";
import userService from "../../../components/Services/user.service";
import { toast } from "react-toastify";
import { toastProperties } from "../../../commons/Toast/Toaster";
import {
  Checkbox,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
 } from "@mui/material";
import {OverlayTrigger, Tooltip } from "react-bootstrap";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const AddNewUser = ({ isOpen, handleUserPopupClose,getAllCompanyAdminUsers }) => {
  const token = useSelector((state) => state?.sessionState?.token);
  const companiesList = useSelector((state) => state?.sessionState?.userList);
  const rolesList = companiesList?.[0].companyRoles?.filter(item => item.role.role !== "COMPANY_ADMIN")
 const initialValues = {
  userName: "",
  password: "",
  email: "",
  phone: "",
  name: "",
  rolesOption: [],
 };
 const validationSchema = Yup.object().shape({
  rolesOption: Yup.array().min(1, "Please select at least one option"),
   userName: Yup.string()
   .required("Username Required")
   .matches(/^[a-zA-Z][a-zA-Z0-9_]{4,19}$/,"Username must start with a letter and can only contain letters, numbers, and underscores, with a length between 5 and 20 characters")
   .test("checkUsername", "Username Already Exists", async function (value) {
    const response = await signUpService.getUsernameExists(value);
    if (response?.data?.code === 400) {
     // Set the field error when the API response indicates an existing username
     throw new Yup.ValidationError(response?.data?.error, value, "userName");
    }
    return true; // Indicates a valid value
   }),
  password: Yup.string()
   .required("Password Required")
   .min(8, "Password Must Be at Least 8 Characters")
   .matches(
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
    "Password Must Contain at Least One Uppercase Letter, One Lowercase Letter, One Number, and One Special Character"
   ),
   email: Yup.string().matches(
    /^(?!.*@(?:hotmail|outlook|yahoo|aol|mail|icloud)\.(?:com|uk|fr|in|net|co\.in)$)\w+(?:[\.-]?\w+)*@\w+(?:[\.-]?\w+)*\.\w{2,6}$/,
    "Please enter a valid company email address. Personal email providers are not allowed.")
  .required("Email Required").test("checkUsername", "Email Already Exists", async function (value) {
    const response = await signUpService.getUsernameExists(value);
    if (response?.data?.code === 400) {
     // Set the field error when the API response indicates an existing username
     throw new Yup.ValidationError(response?.data?.error, value, "email");
    }
    return true; // Indicates a valid value
   }),
  phone: Yup.string()
   .required("Phone Number Required")
   .matches(
    /^[5-9][0-9]{9}$/,
    "Phone Number Must Start with 5 to 9 and Be a Valid 10-Digit Number"
   ),
 });
 const numberInputOnWheelPreventChange = (e) => {
  e.target.blur();
  e.stopPropagation();
  // Refocus immediately, on the next tick (after the current function is done)
  setTimeout(() => {
   e.target.focus();
  }, 0);
 };

 const addNewUser = (data)=>{
  userService.addNewUserFromCompanyAdmin(data).then((response)=>{
    if(response?.data?.code === 200){
      handleUserPopupClose();
      toast.success(response?.data?.message,toastProperties);
      getAllCompanyAdminUsers();
    }
  }).catch(err => console.log("Api Call Error: ",err));
}

const ITEM_HEIGHT = 48;
 const ITEM_PADDING_TOP = 8;
 const MenuProps = {
  PaperProps: {
   style: {
    maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    width: 250,
   },
  },
 };

 return (
  <>
   <Modal show={isOpen} onHide={handleUserPopupClose} centered size="xl">
    <Modal.Header closeButton>
     <Modal.Title>Add New User</Modal.Title>
    </Modal.Header>
    <Modal.Body className="m-3">
     <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      validateOnBlur={false}
      onSubmit={(values) => {
        let reqBody = {
          "userName": values.userName,
          "email": values.email,
          "password": values.password,
          "phone": values.phone,
          "roles": values.rolesOption,
        }
        addNewUser(reqBody);
      }}
     >
      {({ values, errors, setFieldValue, setFieldTouched, setFieldError }) => {
        console.log("Form_value_addNewUser==>",{values,errors});
       return (
        <Form>
         <Row className="mb-3">
          <Col md={6}>
           <label htmlFor="userName">Username*</label>
           <Field
            name="userName"
            type="any"
            className="form-control custom-input"
            onChange={(e) => {
              setFieldValue("userName", e.target.value.toLowerCase());
             }}
           />
           <ErrorMessage
            name="userName"
            className="text-danger"
            component="div"
           />
          </Col>
          <Col md={6}>
           <label htmlFor="password">Password*</label>
           <Field
            type="any"
            style={{ WebkitTextSecurity: "disc" }}
            name="password"
            className="form-control custom-input"
           />
           <ErrorMessage
            name="password"
            className="text-danger"
            component="div"
           />
          </Col>
         </Row>
         <Row className="mb-3">
          <Col md={6}>
           <label htmlFor="email">Email*</label>
           <Field
            type="email"
            name="email"
            // readOnly
            className="form-control custom-input"
           />
           <ErrorMessage name="email" className="text-danger" component="div" />
          </Col>
          <Col md={6}>
           <label htmlFor="phone">Phone Number*</label>
           <Field
            type="number"
            onWheel={numberInputOnWheelPreventChange}
            name="phone"
            className="form-control custom-input"
           />
           <ErrorMessage name="phone" className="text-danger" component="div" />
          </Col>
         </Row>
         <Row>
          <Col md={6}>
          <div >
          <label>
                   Roles &nbsp;
                   <OverlayTrigger
                    placement="right"
                    overlay={
                     <Tooltip>
                      You can Select Multiple Roles.
                     </Tooltip>
                    }
                   >
                    <InfoOutlinedIcon fontSize="small" />
                   </OverlayTrigger>
                  </label>
          <Select
           labelId="demo-multiple-name-label"
           id="demo-multiple-name"
           multiple
           name="rolesOption"
           value={values?.rolesOption}
           onChange={(e) => setFieldValue("rolesOption", e.target.value)}
           renderValue={(selected) => {
            // Get the Names of the selected items
            const selectedUserNames = rolesList
              .filter((item) => selected.includes(item?.role?.role))
              .map((item) => item.role?.role);
            // Join the Names with a comma separator
            return selectedUserNames.join(', ');
          }}
           style={{width:'100%'}}
           MenuProps={MenuProps}
          >
           {rolesList?.map((item, i) => (
            <MenuItem key={i} value={item?.role?.role}>
              <Checkbox checked={values?.rolesOption.indexOf(item?.role?.role) > -1} />
              <ListItemText primary={item?.role?.role} />
            </MenuItem>
           ))}
          </Select>
          <ErrorMessage
           name="rolesOption"
           className="text-danger"
           component="div"
          />
         </div>            
          </Col>
         </Row>
         <hr
        style={{ width: "100%", margin: "20px auto", marginBottom: "20px" }}
       ></hr>
       <Row className="mb-3">
        <div className="text-center mt-4 fw-bold">
         <Button className="btn btn-lg btn-signup" type="submit">
          Submit
         </Button>
        </div>
       </Row>
        </Form>
       );
      }}
     </Formik>
    </Modal.Body>
   </Modal>
  </>
 );
};

export default AddNewUser;
